// 受支持语言清单的单一来源。
// 下沉到包里是为了切断 inngest 事件类型 -> lib/i18n/resources（静态 JSON 全量打包）的依赖边，
// 让独立 API 服务发事件时不用把多语言资源打进构建产物。
// 主站 lib/i18n/resources.ts 从这里 re-export，翻译 JSON 仍留在主站。
export const SUPPORTED_LOCALES = ['en', 'zh', 'es', 'fr', 'de', 'ja', 'ko', 'pt'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

// 把任意输入（'zh-CN' / 'pt-BR' / cookie 值等）按前缀归一化为受支持的 locale；
// 不匹配时返回 fallback（开放 API 场景默认英文）。
export function normalizeLocaleOr(value: string | null | undefined, fallback: Locale = 'en'): Locale {
    const s = (value ?? '').trim().toLowerCase();
    for (const locale of SUPPORTED_LOCALES) {
        if (s.startsWith(locale)) return locale;
    }
    return fallback;
}
